import type { EquipmentStatus, EquipmentType } from "@crewledger/shared/schemas";
import { cn } from "@/lib/utils";
import { EQUIPMENT_STATUS_LABELS, EQUIPMENT_TYPE_LABELS } from "../api";

const TYPE_STYLES: Record<EquipmentType, string> = {
  HEAVY_EQUIPMENT: "bg-navy-deep text-white",
  VEHICLE: "bg-navy-blueprint text-white",
  TOOL: "bg-slate-600 text-white",
  RENTAL: "bg-orange-construction text-navy-deep",
  OTHER: "bg-slate-200 text-slate-700",
};

const STATUS_STYLES: Record<EquipmentStatus, string> = {
  AVAILABLE: "bg-green-50 text-green-700 border-green-200",
  IN_USE: "bg-blue-50 text-blue-700 border-blue-200",
  MAINTENANCE: "bg-amber-50 text-amber-800 border-amber-200",
  OUT_OF_SERVICE: "bg-red-50 text-red-700 border-red-200",
};

export function EquipmentTypeBadge({ type }: { type: EquipmentType }) {
  return (
    <span
      className={cn(
        "inline-flex rounded-md px-2 py-0.5 text-xs font-semibold",
        TYPE_STYLES[type],
      )}
    >
      {EQUIPMENT_TYPE_LABELS[type]}
    </span>
  );
}

export function EquipmentStatusBadge({ status }: { status: EquipmentStatus }) {
  return (
    <span
      className={cn(
        "inline-flex rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        STATUS_STYLES[status],
      )}
    >
      {EQUIPMENT_STATUS_LABELS[status]}
    </span>
  );
}
